"use client";

import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-center"
      richColors={false}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border group-[.toaster]:shadow-2xl group-[.toaster]:rounded-xl group-[.toaster]:p-6 group-[.toaster]:min-w-[450px] group-[.toaster]:max-w-[600px] group-[.toaster]:backdrop-blur-sm group-[.toaster]:border-opacity-20 group-[.toaster]:font-medium group-[.toaster]:text-base group-[.toaster]:flex group-[.toaster]:items-start group-[.toaster]:gap-3",
          description:
            "group-[.toast]:text-gray-600 group-[.toast]:text-sm group-[.toast]:mt-2 group-[.toast]:leading-relaxed",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-lg group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:text-sm group-[.toast]:font-semibold group-[.toast]:hover:bg-primary/90 group-[.toast]:transition-colors",
          cancelButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-700 group-[.toast]:rounded-lg group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:text-sm group-[.toast]:font-semibold group-[.toast]:hover:bg-gray-200 group-[.toast]:transition-colors",
          closeButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-500 group-[.toast]:hover:bg-gray-200 group-[.toast]:rounded-lg group-[.toast]:p-2 group-[.toast]:transition-colors group-[.toast]:ml-auto",
          title:
            "group-[.toast]:font-semibold group-[.toast]:text-lg group-[.toast]:leading-tight",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
